export enum ProtectionPlanEnum {
  PROTECTION_2500 = 'protection_2500',
  PROTECTION_1000 = 'protection_1000',
  /** Free $1k tier for Challenger V2 checkout; distinct plan for $0 Stripe pricing */
  PROTECTION_1000_INCLUDED = 'protection_1000_included',
  MINIMAL_COVERAGE = 'minimal_coverage',
}

type ProtectionPlan = {
  name: string;
  label: string;
  cost: number;
  coverage: string;
};

const PROTECTION_2500: ProtectionPlan = {
  name: '$2500 Max. Coverage',
  label: 'Premium',
  cost: 25,
  coverage: '$2,500',
};

const PROTECTION_1000: ProtectionPlan = {
  name: '$1000 Max. Coverage',
  label: 'Standard',
  cost: 15,
  coverage: '$1,000',
};

const PROTECTION_1000_INCLUDED: ProtectionPlan = {
  name: '$1000 Max. Coverage (Included)',
  label: 'Standard',
  cost: 0,
  coverage: '$1,000',
};

export const PROTECTION_MINIMAL_COVERAGE: ProtectionPlan = {
  name: 'Minimal Coverage ($1.00 / lb.)',
  label: '',
  cost: 0,
  coverage: '',
};

export const PROTECTION_PLANS: Record<ProtectionPlanEnum, ProtectionPlan> = {
  [ProtectionPlanEnum.PROTECTION_2500]: PROTECTION_2500,
  [ProtectionPlanEnum.PROTECTION_1000]: PROTECTION_1000,
  [ProtectionPlanEnum.PROTECTION_1000_INCLUDED]: PROTECTION_1000_INCLUDED,
  [ProtectionPlanEnum.MINIMAL_COVERAGE]: PROTECTION_MINIMAL_COVERAGE,
};

/** Challenger checkout display names (Figma). Classic labels stay on PROTECTION_PLANS. */
const CHALLENGER_PROTECTION_PLAN_LABELS: Record<ProtectionPlanEnum, string> = {
  [ProtectionPlanEnum.MINIMAL_COVERAGE]: 'Standard',
  [ProtectionPlanEnum.PROTECTION_1000]: 'Premium',
  [ProtectionPlanEnum.PROTECTION_1000_INCLUDED]: 'Premium',
  [ProtectionPlanEnum.PROTECTION_2500]: 'Exclusive',
};

export type ProtectionPlanNaming = 'classic' | 'challenger';

export const protectionPlanLabel = (
  plan: ProtectionPlanEnum,
  naming: ProtectionPlanNaming = 'classic',
): string =>
  naming === 'challenger'
    ? CHALLENGER_PROTECTION_PLAN_LABELS[plan]
    : PROTECTION_PLANS[plan].label;
